export default "__VITE_ASSET__EJj4jcXu__"